import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, FormFeedback, Input } from 'reactstrap';

import moment from 'moment';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import Pagination from "react-js-pagination";
import ReactToPrint from 'react-to-print';
import swal from 'sweetalert';
import { TableLoader } from '../../../components/Loaders';
import { reputeinfoActions } from "../../actions";
import { reputeinfoConstants } from '../../constants';
import CallDone from '../ContactUsDetail/CallDone';
import { handleValidation } from './Validation';

class RegistrationAttemptLog extends Component {
    constructor(props) {
        super(props)

        let days = new Date().getDate();
        this.state = {
            // startDate: moment().subtract(days, 'days'),
            startDate: moment(),
            endDate: moment(),
            serachField: {
                dateRange: moment().format("DD MMM Y")
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },
            SearchKey: '',
            errors: {},
            columns: '',
            csv_data: [],
            modalOpan: false,
            is_disable: true,
            page: {
                activePage: 1,
                perPage: 50,
                totalItemsCount: 0
            },
        }
        this.componentRef = '';
        this.getData = this.getData.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleEvent = this.handleEvent.bind(this)
        this.changeSearchFunc = this.changeSearchFunc.bind(this)
        this.handleCalledButton = this.handleCalledButton.bind(this)

    }
    componentDidMount() {
        this.getData()
    }
    handleEvent(event, picker) {
        var start = picker.startDate.format("DD MMM Y");
        var end = picker.endDate.format("DD MMM Y");
        let label = start + ' to ' + end;
        if (start === end) {
            label = start;
        }
        this.setState({
            startDate: picker.startDate,
            endDate: picker.endDate,
            serachField: {
                dateRange: label
            },
            errors: {}
        })
    }



    getData() {

        const result = handleValidation(this.state.serachField)

        this.setState({ errors: result.errors })

        if (result.formIsValid) {
            const { dispatch } = this.props;
            const { page, startDate, endDate } = this.state;
            let dataToSend = {
                active_page: page.activePage,
                per_page: page.perPage,
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
                keyword: this.state.SearchKey
            }
            dispatch(reputeinfoActions.getRecentRegistrAttempt(dataToSend));
        }
    }
    handlePageChange(pageNumber) {
        const { page } = this.state;
        page.activePage = pageNumber;
        this.setState({ page }, () => this.getData());

    }
    componentWillReceiveProps(props) {
        let { page } = this.state
        page.totalItemsCount = 0;
        if (props.data) {
            page.totalItemsCount = props.data.total_records
        }
        this.setState({
            page,
        })
    }


    handleReset() {
        const { dispatch } = this.props;
        this.setState({
            startDate: moment(),
            endDate: moment(),
            serachField: {
                dateRange: moment().format("DD MMM Y")
            },
            errors: {},
            SearchKey: '',
        });

        dispatch({ type: reputeinfoConstants.GET_RECENT_REGISTRATIONS_FAILURE });
    }
    changeSearchFunc(e) {
        this.setState({
            ...this.state, SearchKey: e.target.value
        })
    }



    handleCalledButton(mobile) {
        const { dispatch } = this.props
        let dataToSend = {
            mobile: mobile,
            status: 1
        }
        swal({
            title: "Are you sure ?",
            text: "Have you made a call to this mobile no. " + mobile + " ?",
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((confirm) => {
            if (confirm) {
                dispatch(reputeinfoActions.postRecentRegistrCallStatus(dataToSend, this));
            }
        });
    }



    render() {
        let { loading, data } = this.props
        const { page, serachField, errors } = this.state;
        console.log("data---", data);
        return (
            <div>

                <Form autocomplete="off">
                    <div className="form-group">
                        <DateRangePicker
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            //onApply={this.handleApply}
                            onEvent={this.handleEvent}
                            ranges={this.state.ranges}
                        >
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Select Date Range" value={serachField.dateRange} id="date_picker" style={{ 'width': '220px' }} />
                                <span className="input-group-btn">
                                    <Button className="default date-range-toggle" onClick={(e) => e.preventDefault()}>
                                        <i className="fa fa-calendar" />
                                    </Button>
                                </span>

                            </div>
                        </DateRangePicker>
                        <span>
                            <Input className='mx-2 d-inline' placeholder='Search ' onChange={this.changeSearchFunc} value={this.state.SearchKey} style={{ 'width': '220px' }} ></Input>
                        </span>
                        <Button color="primary" onClick={(e) => this.getData()} style={{ 'margin-left': '10px' }}>Fetch</Button>
                        <Button color="secondary" onClick={(e) => this.handleReset()} style={{ 'margin-left': '10px' }}>Reset</Button>
                        <span style={{ fontSize: 20 }} className='mx-4 ' >
                            <b>
                                Total Lead :  <span className='bg-success mx-2 px-2 rounded  my-auto '> {page && page.totalItemsCount}</span>
                            </b>


                            <b>
                                Total WM  : <span className='bg-success mx-2 px-2 rounded  '> {data && data.total_wm}
                                </span>
                            </b>
                        </span>
                        <ReactToPrint
                            trigger={() => {
                                return <Button color='primary' className='pull-right btn-primary'>Print</Button>
                            }}
                            content={() => this.componentRef}
                        />
                        <FormFeedback>
                            {errors[`dateRange`] && errors[`dateRange`]}
                        </FormFeedback>

                    </div>

                </Form>

                {
                    loading ? <TableLoader /> :
                        <div ref={el => (this.componentRef = el)} className="table-responsive-sm  animated fadeIn">
                            <table className="table table-sm table-condensed  table-bordered  table-outline ">
                                <thead className="thead-light">
                                    <tr>
                                        <th>SR.NO.</th>
                                        <th>Person Name</th>
                                        <th>Company Name</th>
                                        <th>Mobile</th>
                                        <th>Platform</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data && data.recentregistered && data.recentregistered.length > 0 ?
                                            data.recentregistered.map((d, i) => {
                                                return (
                                                    <React.Fragment>
                                                        <tr>
                                                            <td rowSpan={2} >
                                                                <h1 className='text-center' style={{ fontSize: "3em" }} >{d.id}</h1>
                                                            </td>
                                                            <td>{d.fullname} &nbsp;
                                                                {d.is_registered ? <span className='badge badge-success'><i class='fa fa-check-circle'></i> Registered</span> : false}
                                                            </td>
                                                            <td>{d.company_name}</td>
                                                            <td>{d.mobile}
                                                                {d.is_wm ?
                                                                    <span className='badge badge-success'>WM</span>
                                                                    : false}
                                                            </td>
                                                            <td><span className='badge badge-danger'>
                                                                {d.login_type}

                                                            </span>
                                                                <CallDone
                                                                    status={d.is_call_done}
                                                                    handleCalledButton={this.handleCalledButton}
                                                                    _id={d.mobile}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td colSpan={5}>
                                                                <div className='row'>
                                                                    <div className='col-6'>
                                                                        <table className='table table-sm'>
                                                                            <tr>
                                                                                <th className=''>Type</th>
                                                                                <th>Log created at</th>
                                                                            </tr>

                                                                            {d.history && d.history.length && Array.isArray(d.history) && d.history.map((each) => {
                                                                                return <tr>
                                                                                    <td>{each.registration_type}</td>
                                                                                    <td>{each.created_at}</td>
                                                                                </tr>
                                                                            })}
                                                                        </table>
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <table className='table table-sm'>
                                                                            <tr>
                                                                                <th className=''>Template</th>
                                                                                <th>Sent At</th>
                                                                            </tr>

                                                                            {d.wm_sent_log && d.wm_sent_log.length ? Array.isArray(d.wm_sent_log) && d.wm_sent_log.map((each) => {
                                                                                return <tr>
                                                                                    <td>{each.template}</td>
                                                                                    <td>{each.when_to_execute}</td>
                                                                                </tr>
                                                                            }) : false}
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                )
                                            })
                                            : <tr><td colSpan="4" className="text-center" style={{ "background-color": "rgba(0, 0, 0, 0.05)" }}>No Data Found</td></tr>

                                    }
                                </tbody>
                            </table>

                            {
                                page.totalItemsCount <= page.perPage ? "" :
                                    <Pagination
                                        activePage={page.activePage}
                                        itemsCountPerPage={page.perPage}
                                        totalItemsCount={page.totalItemsCount}
                                        pageRangeDisplayed={5}
                                        linkClass="page-link"
                                        itemClass="page-item"
                                        onChange={this.handlePageChange}
                                    // hideNavigation={false}
                                    // hideFirstLastPages={true}
                                    />
                            }
                        </div>
                }

            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading, data } = state.recentRegisternAttempt

    return {
        loading,
        data,
    }
}
const connected = connect(mapStateToProps)(RegistrationAttemptLog)
export { connected as RegistrationAttemptLog };

